import {
  Avatar,
  DateSpan,
  Dialog,
  Dropdown,
  IconButton,
  Menu,
  MenuItemProps,
  Metadata,
  useListGraphqlQuery,
  useRuntimeEnv,
  useTranslationRoute,
  useTranslations,
  useUrlParamsValueToString,
  useUserProfilePicture,
} from "@bsm/component";
import { TTimeOff } from "@bsm/graphql";
import { VacationDates } from "components/VacationDates";
import { VacationResponse } from "components/VacationResponse";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useDayOffDeleteMutation } from "views/dayoff/hooks/useDayOffDeleteMutation";
import { useInlineMIssingItemMenu } from "views/dayoff/hooks/useInlineMIssingItemMenu";
import { MISSING_DAYOFF_LIST_ID } from "../container/ProjectDayOffMissingContainer";

export const MissingListItem = (props: VacationUserDetailsItemsProps) => {
  const [
    DAYS,
    NEW,
    CREATED_AT,
    CONFIRM,
    CANCEL,
    CONFIRMATION_TITLE,
    MESSAGE_CONFIRMATION,
  ] = useTranslations(i18n);
  const userProfilePicture = useUserProfilePicture();
  const tr = useTranslationRoute();
  const [wantToDeleteDayOff, setWantToDeleteDayOff] = useState(false);
  const urlParamsToString = useUrlParamsValueToString();
  const urlParams = useUrlParamsValueToString();
  const [menuState, setMenuState] = useState<{
    anchorEl: HTMLElement | null;
    id: number | null;
  }>({
    anchorEl: null,
    id: null,
  });
  const mutation = useDayOffDeleteMutation();
  const { invalidateQuery } = useListGraphqlQuery(MISSING_DAYOFF_LIST_ID);

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: number
  ) => {
    setMenuState({ anchorEl: event.currentTarget, id });
  };
  const handleCloseMenu = () => {
    setMenuState((prevState) => ({ ...prevState, anchorEl: null }));
  };
  const menuEllipsisItems = useInlineMIssingItemMenu();

  const handleMenuClick = (menu: MenuItemProps) => {
    if (menu.ke === "delete") {
      setWantToDeleteDayOff(true);
    }
    handleCloseMenu();
  };

  const deleteDayOff = () => {
    mutation.mutate(
      { ids: [props?.id] },
      {
        onSuccess: () => {
          invalidateQuery();
          setWantToDeleteDayOff(false);
        },
      }
    );
  };

  return (
    <div className="w-full flex flex-col gap-2 bg-white p-3">
      <div className="flex items-center justify-between">
        <div className="grid grid-cols-12 gap-2">
          <div className="col-span-1 place-self-center">
            <Avatar
              size="md"
              src={userProfilePicture(props.employee?.id)}
              fullName={props.employee?.fullName}
            />
          </div>
          <div className="col-span-4 self-center">
          <Link
            to={tr(
              `admin/project/dayoff/missing/${props.id}?${urlParamsToString}`
            )}
          >
            <h3 className="text-base font-semibold">
              {props.employee?.fullName}
            </h3>
          </Link></div>
          <VacationDates {...props} />
          <div className="col-span-2 place-self-center">
            <Metadata
              label={CREATED_AT}
              value={<DateSpan value={props.createdAt} />}
            />
          </div>
        </div>
        <IconButton
          icon={"fa-ellipsis-vertical"}
          onClick={(e) => handleOpenMenu(e, props?.id)}
        />
        {menuState.id === props?.id && (
          <Dropdown
            anchorEl={menuState.anchorEl}
            arrow
            placement="bottom-end"
            onClose={handleCloseMenu}
          >
            <Menu items={menuEllipsisItems} onClick={handleMenuClick} />
          </Dropdown>
        )}
      </div>
      <VacationResponse {...props} />
      <Dialog
        open={wantToDeleteDayOff}
        confirmation
        title={CONFIRMATION_TITLE}
        message={MESSAGE_CONFIRMATION}
        onConfirm={deleteDayOff}
        btnOk={{ label: CONFIRM, isSubmit: mutation.isLoading }}
        btnCancel={{ label: CANCEL }}
        onClose={() => {
          setWantToDeleteDayOff(false);
        }}
      />
    </div>
  );
};
export type VacationUserDetailsItemsProps = Partial<TTimeOff>;

const i18n = [
  "std_days",
  "std_new",
  "std_created_at",
  "std_confirm",
  "std_cancel",
  "std_confirmation",
  "BSMRH.DayOff.Absence.Delete.Confirm.Message",
];
